import { JuloUpdateEntry } from "./types"

export const obligatoriskaAtgarderEntry: JuloUpdateEntry = {
  slug: "2026-07-09-obligatoriska-atgarder",
  date: "2026-07-09",
  title: "Markera åtgärder som obligatoriska",
  description:
    'Ni kan nu markera en åtgärd som obligatorisk, så att kunden inte kan välja bort den när de svarar på förslaget eller tilläggsordern. I tilläggsordern och mottagningen gör ni det via de tre prickarna bredvid åtgärden och väljer "Markera obligatorisk"; i besiktningen klickar ni på hänglås-ikonen bredvid rabatt-ikonen på komponentkortet. En "Obligatorisk"-etikett dyker då upp på åtgärden — klicka på krysset i etiketten för att ta bort obligatoriskheten igen. Obligatoriska åtgärder är förkryssade och låsta för kunden i marknadsplatsen, och räknas alltid med i totalen. Fungerar för komponentåtgärder, manuella åtgärder och tvätt.',
  images: [
    {
      src: "/julo-updates/2026-07-09-obligatoriska-atgarder/markera-obligatorisk-meny.png",
      alt: 'Menyn bakom de tre prickarna på en komponentåtgärd (Byt kedja) i en order, med valen "Lägg till rabatt", "Markera obligatorisk" och "Ta bort åtgärd".',
    },
    {
      src: "/julo-updates/2026-07-09-obligatoriska-atgarder/las-ikon-besiktning.png",
      alt: "Ett komponentkort (Styre och styrstam) i besiktningen med en hänglås-ikon bredvid rabatt-ikonen, som markerar åtgärden som obligatorisk.",
    },
  ],
}
